<template>
  <div class="newmmsubsim">
    <!-- {{ defaultFiles }} -->
    <div v-for="(rib,ribidx) in reqImgBackgroundChild" :key="ribidx" class="positon-r mouseC">
      <drop @drop="sumimagesort(ribidx, $event)">
        <drag :transfer-data="{ index: ribidx, mark:'subimgs' }">
          <div class="imgClose" v-if="rib.url !== null" @click="childMethosod(ribidx,rib.url)">
            <button type="button" aria-label="Close" class="close">×</button>
          </div>
          <div class="dropboxDiv sub" @click="dropboxClick(ribidx)">
            <input type="file" :ref="'fileInput' + ribidx" style="display:none;" accept="image/jpeg, image/png"
                   @change="onUploadFiles($event)"/>
            <div :style="'background-image:url('+rib.url+')'" :class="'dropbox dropbox'+ribidx"
                 v-on:dragover="allowDrop" v-on:drop="ondrop($event,0)" @dragenter="onDragenter">
            </div>
          </div>
        </drag>
      </drop>
    </div>
  </div>
</template>

<script>
import api from "../../constants/api";
import Axios from "axios";
import {
  mapGetters
} from "vuex";
import Compressor from "compressorjs";

const {
  BlobServiceClient,
  ContainerClient
} = require('@azure/storage-blob');

import {
  Drag,
  Drop
} from "vue-drag-drop";

export default {
  components: {
    Drag,
    Drop,
  },
  props: ['defaultFiles', 'container', 'newsubimguse', 'subImagesBtnType', 'fakeIndex'],
  mounted() {
    if (this.newsubimguse) {
      if (this.subImagesBtnType === 'edt') {
        let add = this.reqImgBackgroundChild.filter(function (item) {
          return item.url !== '';
        });
        if (add.length < 3) {
          this.checkedImgLength.push(null);
          let newArr = [];
          this.reqImgBackgroundChild.forEach((el, idxs) => {
            newArr.push({
              "width": el.width,
              "height": el.height,
              "url": el.url,
              "azureUrl": el.url,
              "idx": idxs,
            })
          });
          this.reqImgBackgroundChild = newArr;
          this.reqImgBackgroundChild.unshift({
            "width": 0,
            "height": 0,
            "url": null,
            "azureUrl": null,
            'firstpar': 'ok',
          })
        } else {
          let newArr = [];
          this.reqImgBackgroundChild.forEach((el, idxs) => {
            newArr.push({
              "width": el.width,
              "height": el.height,
              "url": el.url,
              "azureUrl": el.url,
              "idx": idxs,
            })
          });
          this.reqImgBackgroundChild = newArr;
          this.reqImgBackgroundChild.forEach(element => {
            this.checkedImgLength.push(element.url)
          });
        }
      }
    }
  },
  data: function () {
    return {
      isLoad: false,
      reqImgBackgroundChild: this.defaultFiles ? this.defaultFiles : [{
        "width": 0,
        "height": 0,
        "url": null,
        "azureUrl": null
      }],
      imageData: [],
      uploadHeaders: {
        'X-Test-Header': 'vue-file-agent'
      },
      checkedImgLength: [],
      removeImg: null,
      imgwidth: 0,
      imgheight: 0,
    };
  },
  watch: {
    defaultFiles(val) {
      this.reqImgBackgroundChild = val;
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName']),
  },

  methods: {
    allowDrop(event) {
      event.preventDefault();
    },
    drag(event) { //드래그 시작시 호출 할 함수
      event.dataTransfer.setData("Text", event.target.id);
      const targetEl = document.getElementById('holder');
    },
    onDragenter(event) {
      event.preventDefault()
    },
    onDragover(event) {
      event.preventDefault()
    },
    ondrop(event, idx) {
      event.preventDefault();
      let data = event.dataTransfer.getData("Text");
      if (event.currentTarget._prevClass === 'dropImgBox') {

      } else {
        if (this.newsubimguse) { //서브이지추가
          if (data === "") {
            return;
          }
          let add = this.reqImgBackgroundChild.filter(function (item) {
            return item.url !== null;
          });
          if (add.length === 3) {
            return
          }
          if (this.reqImgBackgroundChild.length === 3) {
            this.reqImgBackgroundChild.shift();
          }
          let url = document.getElementById(data).src;
          let width = document.getElementById(data).width;
          let height = document.getElementById(data).height;
          this.fakeIndex.push(url)
          this.checkedImgLength.push(url);
          this.reqImgBackgroundChild.push({
            "width": width,
            "height": height,
            "url": url,
            "idx": Number(this.fakeIndex.length) - 1,
          })
          this.$emit('newimgadd', this.reqImgBackgroundChild);
        } else {
          this.reqImgBackground = document.getElementById(data).src;
          // event.target.appendChild(document.getElementById(data));
          let url2 = document.getElementById(data).src;
          let width2 = document.getElementById(data).width;
          let height2 = document.getElementById(data).height;
          this.reqImgBackgroundChild = [{
            'width': width2,
            'height': height2,
            'url': url2,
            'azureUrl': url2
          }];
          this.$emit('newimgadd', url2, width2, height2);
        }

      }
      // }
    },
    dropboxClick(idx) {
      // console.log(this.reqImgBackgroundChild[idx]);
      console.log(this.reqImgBackgroundChild);
      let zeroNoClickArr = [];
      for (const x in this.reqImgBackgroundChild) {
        if(this.reqImgBackgroundChild[x].azureUrl === null){
          zeroNoClickArr.push(true);
        }else{
          zeroNoClickArr.push(false);
        }
      }
      if(idx !== 0){
        return;
      }
      if(idx === 0 && !zeroNoClickArr.includes(true)){
        return;
      }
      this.$refs['fileInput' + idx][0].click();
    },
    childMethosod(idx, url) {
      this.parantRemove(url, idx);
    },
    sumimagesort(drop, drag) {
      if (drag !== undefined) {
        if (drag.mark != 'subimgs') {
          return;
        }
        var t_array = this.reqImgBackgroundChild;
        this.reqImgBackgroundChild = [];
        var b = t_array[drag.index];
        t_array[drag.index] = t_array[drop];
        t_array[drop] = b;
        this.reqImgBackgroundChild = t_array;
        this.$emit('newimgadd', this.reqImgBackgroundChild);

      }
    },
    parantRemove: function (val, imgidx) {
      if (this.newsubimguse) { // 서브이미지일경우

        let vm = this;
        if (this.reqImgBackgroundChild[imgidx].idx !== 'uploadedUrl' && this.reqImgBackgroundChild[imgidx].idx !== null) {
          let fakeArrayIdxArr = vm.reqImgBackgroundChild.filter(function (item) {
            return item.idx !== vm.reqImgBackgroundChild[imgidx].idx;
          });
          this.reqImgBackgroundChild = fakeArrayIdxArr;
        } else {
          let fakeArrayIdxArr = vm.reqImgBackgroundChild.filter(function (item) {
            return item.url !== val;
          });
          this.reqImgBackgroundChild = fakeArrayIdxArr;
        }
        let add = this.reqImgBackgroundChild.filter(function (item) {
          return item.url !== null;
        });
        console.log(add);

        if (add.length === 2) {
          this.reqImgBackgroundChild.unshift({
            "width": 0,
            "height": 0,
            "url": null,
            "azureUrl": null,
            'firstpar': 'ok',
            idx: null
          })
        }
        this.$emit('newimgadd', this.reqImgBackgroundChild);
        this.checkedImgLength.shift();
      } else {
        let findss = this.reqImgBackgroundChild.filter(function (item) {
          let uurrll = '';
          if (item.azureUrl) {
            uurrll = item.azureUrl
          } else {
            uurrll = item.url
          }
          return uurrll !== val;
        });
        this.reqImgBackgroundChild = [{
          "width": 0,
          "height": 0,
          "url": null,
          "azureUrl": null
        }];
        this.$emit('getFileData', findss);
      }
    },
    onUploadFiles(event) {
      let imageFile = event.target.files[0];
      if(imageFile === undefined){
        return;
      }
      this.compressImage(imageFile).then((compressedFile) => {
        let reader = new FileReader();
        reader.readAsDataURL(compressedFile);
        reader.onload = evt => {
          let img = new Image();
          img.onload = () => {
            this.imgwidth = img.width;
            this.imgheight = img.height;
          }
          img.src = evt.target.result;
        }

        reader.onerror = evt => {
          console.error(evt);
        }

        this.filesSelected(compressedFile);
      }).catch((error) => {

        alert("이미지 리사이징 에러입니다.");
      });
    },
    filesSelected: function (filesDataNewlySelected) {
      let compressFilePromises = [];

      compressFilePromises.push(filesDataNewlySelected)

      const vm = this;

      let reqURL = api.changeAPI(vm.siteName, api.basicURL + api.user.azureSas);
      let params = {
        type: vm.container
      }

      Promise.all(compressFilePromises).then(values => {
        let fileListToUpload = values;
        vm.$http.post(reqURL, params, {
          headers: {
            'Authorization': `Bearer ${vm.currentUser.tokens.access.token}`
          }
        }).then(res => {
          if (res.data.code === "OK") {

            // console.log("sas", res.data);
            let containerUrl = res.data.data.url
            const containerClient = new ContainerClient(containerUrl);

            fileListToUpload.forEach(function (fileToUpload, index) {
              const now = vm.$moment(new Date()).format('YYYYMMDDHHmmss')

              const blockBlobClient = containerClient.getBlockBlobClient(`${res.data.data.directory}/${now}` + index);

              blockBlobClient.uploadBrowserData(fileToUpload, {
                blockSize: 4 * 1024 * 1024, // 4MB block size
                // concurrency: 20,
                blobHTTPHeaders: {
                  blobContentType: fileToUpload.type
                }

              }).then(success => {
                let uploadedUrl = success._response.request.url.substring(0, success._response.request.url.indexOf("?sig="))
                let _tmpImg = new Image();
                vm.imageData = [];
                _tmpImg.onload = function () {
                  vm.imageData.push({
                    height: _tmpImg.height,
                    width: _tmpImg.width,
                    azureUrl: uploadedUrl,
                    url: uploadedUrl,
                    idx: null,
                  })
                  let findss = vm.checkedImgLength.filter(function (item) {
                    return item !== null;
                  });
                  vm.checkedImgLength = findss;
                  if (vm.checkedImgLength.length > 3) {
                    return;
                  }
                  vm.checkedImgLength.push(uploadedUrl);
                  vm.usefilesData(vm.imageData);
                }
                _tmpImg.src = uploadedUrl;
              }).catch(reason => {
                let _idx = (vm.reqImgBackgroundChild.length - compressFilePromises.length) + index;
                vm.reqImgBackgroundChild.splice(_idx, 1)
                alert("업로드 실패")
              })
            });
            // resolve('ssss')
          } else {
            throw 400
          }
        }).catch(err => {
          alert("이미지 파일을 업로드하지 못하였습니다.");
        });
      }).catch((error) => {
        console.log(error);
        alert("이미지 리사이징 에러입니다.");
      });

    },
    compressImage(imageFile) {
      return new Promise((resolve, reject) => {
        let allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

        if (!allowedExtensions.exec(imageFile.name)) {
          resolve(imageFile);
        } else {
          new Compressor(imageFile, {
            maxWidth: 600,
            quality: 0.8,
            success(result) {
              resolve(result)
            },
            error(e) {
              reject(e)
            },
          });
        }
      });
    },
    usefilesData(val) {
      if (val) {
        if (this.newsubimguse) {
          if (this.checkedImgLength.length > 3) {
            return;
          }
          val.forEach(el => {
            if (el.url !== null && el.url !== undefined) {
              this.reqImgBackgroundChild.push(el)
            }
          });
          console.log(this.reqImgBackgroundChild)
          if (this.reqImgBackgroundChild.length === 4) {
            this.reqImgBackgroundChild.forEach((el, idx) => {
              if (el.url === null) {
                this.reqImgBackgroundChild.splice(idx, 1)
              }
            });
          }
          this.$emit('newimgadd', this.reqImgBackgroundChild);
          this.fakeIndex.push('s') //이미지 삭제시 사용
        } else { //대표이미지일경우
          let url2 = val[0].url;
          let width2 = val[0].width;
          let height2 = val[0].height;
          this.$emit('newimgadd', url2, width2, height2);
          this.reqImgBackgroundChild = [{
            'width': width2,
            'height': height2,
            'url': url2,
            'azureUrl': url2
          }];
        }
        // this.spinning = false;
      }

    },
    uploadImgArr() {
      let add = this.reqImgBackgroundChild.filter(function (item) {
        return item.url !== null;
      });
      this.$emit('newimgadd', add);
    },

  },
};
</script>

<style lang="scss" scoped>
.list-move {
  transition: transform 1s;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter,
.list-leave-to

  /* .list-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

input::placeholder {
  color: #b0b0b0;
}

.imgBoxDivGroup {
  width: 50%;
}

.imgBoxDivGroup .imgDragbox {
  width: 100%;
}

.imgBoxDivGroup {
  display: flex;
  width: 100%;
  justify-content: center;
}

.imgboxChild:nth-child(1n) {
  margin-right: 10px;
}

.imgBoxDivGroup > div .imgboxChild {
  height: 200px;
  width: 200px;
  margin-bottom: 10px;
  display: inline-block;
  object-fit: contain;
  background: #f5f5f5;
  padding: 10px;
}

.imgDragbox {
  text-align: center;
  padding: 20px;
  margin-left: 20px;
  width: 50%;
}

.dropbox img {
  display: none !important;
}

.dropbox {
  width: 100%;
  height: 100%;
  margin: auto;
  background-size: 100%;
  background-position: center center;
  background-repeat: no-repeat;
}

.dropboxDiv {
  width: 400px;
  height: 300px;
  padding: 24px;
  background: #f2f2f2;
  border: 1px solid #dedede;
  position: relative;
  background: #f2f2f2 url(/assets/img/plusimg.PNG);
  background-repeat: no-repeat;
  background-position: center;
}

.dropboxDiv.sub {
  width: 200px;
  height: 150px;
}

.partentDiv {
  position: relative;
}

.imgClose {
  position: absolute;
  right: 9px;
  z-index: 99;
  top: 5px;
}

.upimg {
  fill: #aaa;
  margin: auto;
  margin-top: 16%;
  height: 36%;
  width: 100%;
}

.help-text {
  color: #aaa;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  height: 20px;
  display: block;
}

.upimgtextbox {
  height: 100%;
}

.imgdragselect {
  width: auto;
  // margin-left: 14px;
  margin-bottom: 10px;
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
  height: auto !important;
}

.imgDragbox-div {
  text-align: left;
}

.btn-default {
  background-color: #f4f4f4;
  color: #444;
  border-color: #ddd;
  border-radius: 0;
}

.dropImgBox {
  height: 400px;
  text-align: left;
}

.addmodals {
  display: flex;
  justify-content: space-between;
}

.addmodals .imgBoxDivGroup {
  width: 50%;
}

.addimgInputGroup {
  width: 45%;
  vertical-align: top;
}

.addmodals .imgBoxDivGroup .imgDragbox {
  width: 100%;
}

.newmmsubsim {
  display: flex;
  justify-content: flex-start;
}

.positon-r {
  position: relative;
}

.mouseC {
  cursor: move;
}

.partentDiv.main .dropboxDiv.sub {
  width: 450px;
  height: 450px;
}
</style>
